<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div style="text-align:center;">
                  <h2>Authentic.net Scanner</h2>
                </div>
              </div>
              <div class="col-md-8 col-md-offset-2">
                <qrcode-reader @decode="onDecode" @locate="onLocate"></qrcode-reader>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="text-center" style="padding-top:20px;">
              <router-link to="/authenticate" class="btn">
                Enter Code Manually
              </router-link>
              <a href="https://authentic.net" class="btn">Authentic.net Home</a>
            </div>
            <div class="copyright text-center">
              &copy; Copyright 2018 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>

  </div>
</template>

<script>
import { QrcodeReader } from 'vue-qrcode-reader'

export default {
  data () {
    return {
    }
  },

  components: { QrcodeReader },

  methods: {
    onDecode (content) {
      console.log('on decode: ' + content)
      // let params = new URLSearchParams(content)
      if (content.includes('scan.authentic.net')) {
        let x = content.split('/')
        let code = x[x.length - 1]
        console.log(code)
        this.$router.push({ name: 'Authenticate', params: { code: code } })
      } else if (content.includes('authentic.net')) {
        let x = content.split('=')
        let code = x[x.length - 1]
        console.log(code)
        this.$router.push({ name: 'Authenticate', params: { code: code } })
      }
    },
    onLocate (points) {
      // console.log('on locate: ' + points)
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Scan.vue